import { GlLink, GlTooltip, GlTooltipDirective, GlIcon } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { STATUS_CLOSED } from '~/issues/constants';
import { __ } from '~/locale';
import TimeagoTooltip from '../../vue_shared/components/time_ago_tooltip.vue?vue3';
import UserAvatarImage from '../../vue_shared/components/user_avatar/user_avatar_image.vue?vue3';
import timeago from '~/vue_shared/mixins/timeago';
export default {
    name: 'TitleSuggestionsItem',
    components: {
        GlTooltip,
        GlLink,
        GlIcon,
        UserAvatarImage,
        TimeagoTooltip
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        timeago
    ],
    props: {
        suggestion: {
            type: Object,
            required: true
        }
    },
    computed: {
        isClosed () {
            return this.suggestion.state === STATUS_CLOSED;
        },
        stateIconClass () {
            return this.isClosed ? 'gl-fill-icon-info' : 'gl-fill-icon-success';
        },
        stateIconName () {
            return this.isClosed ? 'issue-close' : 'issue-open-m';
        },
        stateTitle () {
            return this.isClosed ? __('Closed') : __('Opened');
        },
        closedOrCreatedDate () {
            return this.suggestion.closedAt || this.suggestion.createdAt;
        },
        hasUpdated () {
            return this.suggestion.updatedAt !== this.suggestion.createdAt;
        }
    }
};
